<template>
   
  <div class="menu">
   <!-- <div @click="toggleCollapsed" class="toggle-menu">
      <svg class="icon" aria-hidden="true">
        <use :xlink:href="'#icon-' + (state.collapsed ? 'zhankai' : 'shouqi')" />
      </svg>
    </div> -->
    <div class="logo" :class="state.collapsed ? 'small-logo' : 'large-logo'">
      <img src="../assets/images/img/artemisads-logo.svg" />
    </div>
    <div class="content">
      <a-menu mode="inline" :items="processMenuItems(menus)" @click="onClick" v-model:openKeys="state.openKeys"
        v-model:selectedKeys="state.selectedKeys" :inline-collapsed="state.collapsed" 
        :class="{ 'has-submenu': hasSubmenu(menus) }" />
      <div class="bottom-entries" v-if="bottomEntries.length">
        <a-menu mode="inline" :items="bottomEntries" @click="onClick" v-model:openKeys="state.openKeys"
          v-model:selectedKeys="state.selectedKeys" :inline-collapsed="state.collapsed" />
      </div>
    </div>
    <contact-us-modal
      v-if="showContactUsModal"
      :open="showContactUsModal"
      :user-type="userType"
      @hide="showContactUsModal = false"
    />
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { ref, onMounted, reactive, watch, defineExpose } from 'vue'
import ContactUsModal from './ContactUsModal.vue'
const {
  menus,
  bottomEntries = [],
  userType = 'publisher',
} = defineProps(['userType', 'menus', 'bottomEntries'])
const route = useRoute()
const router = useRouter()
const state = ref({
  collapsed: false,
  selectedKeys: [userType === 'admin' ? 'operator/users' : `/${userType}/products`],
  openKeys: [],
  preOpenKeys: [],
})
const showContactUsModal = ref(false)

// 判断菜单是否有子菜单
const hasSubmenu = (menuItems) => {
  if (!menuItems || !Array.isArray(menuItems)) return false
  return menuItems.some(item => item?.children && item?.children.length > 0)
}

// 处理菜单项，为子菜单添加特殊class
const processMenuItems = (items) => {
  // console.log(items,'item')
  if (!items || !Array.isArray(items)) return []
  return items.map(item => {
    if (item && item?.children && item.children.length > 0) {
      return {
        ...item,
        children: processMenuItems(item.children).map(child => ({
          ...child,
          class: 'submenu-item'
        }))
      }
    }
    return item
  }).filter(Boolean) // 过滤掉 null 或 undefined 项
}

// 添加获取特定菜单项 DOM 元素的方法
const getMenuItemElement = (label) => {
  const menuItems = document.querySelectorAll('.ant-menu-item, .ant-menu-submenu-title')
  for (let item of menuItems) {
    const textContent = item.textContent?.trim()
    if (textContent === label) {
      return item
    }
  }
  return null
}

// 暴露方法给父组件
defineExpose({
  getMenuItemElement,
  toggleCollapsed
})

function getSelected() {
  let key
  let arr = route.path.split('/').filter(item => item !== '') // 过滤空字符串
  let temp = []

  // 递归收集所有菜单项
  function collectMenuItems(menuItems) {
    if (!menuItems || !Array.isArray(menuItems)) return
    menuItems.forEach((v) => {
      if (v) {
        temp.push(v)
        if (v?.children) {
          collectMenuItems(v.children)
        }
      }
    })
  }
  
  collectMenuItems((menus || []).concat(bottomEntries || []))
  if (route.path.indexOf('/brand/detail/') !== -1) {
    arr[1] = 'brand-index'
  } else if (arr.length == 3 && !/\d/g.test(arr[2])) {
    arr[1] = arr[1] + '-' + arr[2]
  } else if (arr.length == 4 && !/\d/g.test(arr[3])) {
    // 对于四层路径，需要特殊处理 Settings/paidPlacement/campaigns 这种情况
    if (arr[1] === 'Settings' && arr[2] === 'paidPlacement') {
      if (arr[3] === 'campaigns') {
        arr[1] = 'settings-paidCampaigns-campaigns'
      } else if (arr[3] === 'placement') {
        arr[1] = 'settings-paidCampaigns-placement'
      }
    } 
    else if (arr[0] === 'operator') {
    // 对于operator开头的路径，生成包含operator前缀的路由名称
    arr[1] = 'operator-' + arr[1] + '-' + arr[2] + '-' + arr[3]
  } 
    else {
      arr[1] = arr[1] + '-' + arr[2] + '-' + arr[3]
    }
  }

  // 调试信息
  // console.log('Current path:', route.path)
  // console.log('Path array:', arr)
  // console.log('Looking for routeName:', arr[1])
  // console.log('Available menu items:', temp.map(v => ({ routeName: v.routeName, key: v.key })))
 
  for (let v of temp) {
    console.log(`Checking menu item: routeName=${v?.routeName}, key=${v?.key}, looking for=${arr[1]}`)
    if (v?.routeName == arr[1]) {
      console.log(`Found matching menu item:`, v)
      key = v.key
      state.value.openKeys = []

      // 递归收集所有需要展开的父菜单
      function collectParentKeys(menuItem) {
        if (menuItem.preKey) {
          console.log(`Collecting parent keys for menu item:`, menuItem)
          console.log(`Adding preKey:`, menuItem.preKey)
          // 避免重复添加
          if (!state.value.openKeys.includes(menuItem.preKey)) {
            state.value.openKeys.push(menuItem.preKey)
            console.log(`Added preKey to openKeys:`, state.value.openKeys)
          }
          // 查找父菜单项并递归收集其父菜单
          const parentMenu = temp.find(item => item.key === menuItem.preKey)
          if (parentMenu) {
            console.log(`Found parent menu:`, parentMenu)
            collectParentKeys(parentMenu)
          }
        }
      }
      
      // 对于三层菜单，需要特殊处理
      // 如果当前菜单项没有preKey，说明它是第三层菜单
      // 需要找到它的父菜单和祖父菜单
      console.log(`Checking if menu item has preKey:`, v.preKey)
      if (!v.preKey) {
        console.log(`Menu item has no preKey, searching for parent menu`)
        // 查找父菜单（第二层）
        const parentMenu = temp.find(item => 
          item.children && item.children.some(child => child.key === v.key)
        )
        console.log(`Found parent menu:`, parentMenu)
        if (parentMenu) {
          // 添加父菜单到openKeys
          console.log(`Adding parent menu key to openKeys:`, parentMenu.key)
          if (!state.value.openKeys.includes(parentMenu.key)) {
            state.value.openKeys.push(parentMenu.key)
            console.log(`Added parent menu key to openKeys:`, state.value.openKeys)
          }
          // 递归收集祖父菜单
          console.log(`Collecting parent keys for parent menu`)
          collectParentKeys(parentMenu)
        }
      } else {
        // 对于有preKey的菜单项，使用原来的逻辑
        console.log(`Menu item has preKey, collecting parent keys`)
        collectParentKeys(v)
      }
      
      // 确保openKeys的顺序正确，父菜单在子菜单之前
      // 这对于Ant Design Menu组件的展开状态很重要
      console.log(`Before sorting openKeys:`, state.value.openKeys)
      state.value.openKeys.sort((a, b) => {
        const aDepth = a.split('/').length
        const bDepth = b.split('/').length
        return aDepth - bDepth
      })
      console.log(`After sorting openKeys:`, state.value.openKeys)
      
      // 去重并排序，确保父菜单在子菜单之前
      state.value.openKeys = [...new Set(state.value.openKeys)]
      console.log(`After deduplication openKeys:`, state.value.openKeys)
       break
    }
  }

  console.log(`Final selectedKeys:`, [key])
  console.log(`Final openKeys:`, state.value.openKeys)
  state.value.selectedKeys = [key]
}

function onClick({ key }) {
  const preSelectedKeys = state.value.selectedKeys
  if (key.includes('/')) {
    router.push(key)
  } else if (key === 'contact-us') {
    showContactUsModal.value = true
    state.value.selectedKeys = [...preSelectedKeys]
  }
}

function toggleCollapsed() {
  state.value.collapsed = !state.value.collapsed
  state.value.openKeys = state.value.collapsed ? [] : state.value.preOpenKeys
}

onMounted(() => {
  getSelected()
})

watch(
  () => state.value.openKeys,
  (_val, oldVal) => {
    state.value.preOpenKeys = oldVal
  }
)

watch(
  () => route.path,
  (val) => {
    getSelected()
  }
)
</script>

<style lang="less" scoped>
 .toggle-menu {
    top: 10px;
    z-index: 4;
    width: 24px;
    // right: -24px;
    height: 28px;
    cursor: pointer;
    position: absolute;
    background: #ffffff;
    border: 1px solid var(--border-4);
    box-shadow: 0 1px 0 0 var(--box-shadow-2);
    border-radius: 0 8px 8px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--dark-3);

    .icon {
      font-size: 12px;
      font-weight: 600;
    }

    &:hover {
      color: var(--dark-3);
      background-color: var(--bg-gray-1);
      border-color: var(--border-1);
    }

    &:active {
      color: var(--dark-2);
      background-color: var(--bg-gray-2);
      border-color: var(--bg-gray-7);
    }
  }
.menu {
  height: 100%;
  display: flex;
  padding-top: 24px;
  position: relative;
  flex-direction: column;
  background: var(--color-white);
  border-right: 1px solid var(--border-4);
  overflow-y: auto;
  
 

  .logo {
    width: 60px;
    height: 40px;
    min-height: 40px;
    overflow: hidden;
    transition: width 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    position: relative;

    img {
      top: 0;
      left: 16px;
      width: 176px;
      height: 40px;
      min-width: 176px;
      position: absolute;
    }
  }

  .large-logo {
    width: 246px;
  }
}

.content {
  height: 100%;
  display: flex;
  margin: 16px 8px 0;
  flex-direction: column;
  justify-content: space-between;
  font-weight: 500 !important;
  :deep(.ant-menu) {
    border-inline-end: none;

    .reports-beta {
      >span {
        padding: 1.5px 4px;
        width: 41px;
        background: var(--bg-gray-8);
        border-radius: 4px;
        font-weight: 500;
        color: var(--dark-3);
        font-size: 12px;
        letter-spacing: 0.3px;
        line-height: 16px;
      }
    }

    &.ant-menu-inline-collapsed {
      width: 56px !important;
    }
    .ant-menu-title-content{
        font-weight: 500 ;
        font-size: 17px;
        line-height: 20px;

      }
      .ant-menu-submenu-title-selected{
        span{
          font-weight: 600 !important;

        }
      }
 &-item,
    &-submenu-title {
      height: 40px;
      display: flex;
      font-size: 15px;
      font-weight: 500;
      line-height: 20px;
      position: relative;
      align-items: center;
      border-radius: 50px;
      color: var(--dark-1);
      letter-spacing: 0.4px;
      border-radius: 8px !important;
      padding-left: 12px !important;
     
      &:hover {
        background-color: var(--bg-gray-6) !important;
      }

      &:active {
        background-color: var(--bg-gray-4) !important;
      }

      &-icon {
        height: 40px;
        flex: 0 0 24px;
        font-size: 24px;
        margin-right: 2px;
      }

      &-selected {
        opacity: 1;
        background-color: var(--primary-selectd);
        color: var(--primary-text);
        border-radius: 50px;
        span{
          font-weight: 600 !important;

        }
        &:hover {
          color: var(--primary-text) !important;
          background-color: var(--primary-selectd) !important;
        }

        &::after {
          top: 10px;
          left: 0;
          width: 3px;
          height: 20px;
          position: absolute;
          border-radius: 50px;
          background-color: var(--primary-text);
        }

        .ant-menu-item-icon {
          opacity: 1;
          font-weight: 500;
          color: var(--primary-text);
        }
      }

      &.ant-menu-item-only-child {
        padding-left: 48px !important;

        &:last-of-type {
          margin-block-end: unset;
        }
      }
    }
    .ant-menu-submenu {
      margin-block: 4px;

      .ant-menu-submenu-arrow {
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        width: 16px;
        height: 16px;
        color: var(--dark-3);
        
        &::before {
          display: none;
        }
        
        &::after {
          position: absolute;
          top: 50%;
          right: 0;
          width: auto;
          height: auto;
          margin: 0;
          display: block;
          font-size: 12px;
          content: '\e75f';
          transform: translateY(-50%) rotate(0deg);
          font-style: normal;
          font-family: 'iconfont';
          background: none;
          transition: transform 0.3s;
        }
      }
      
      &.ant-menu-submenu-open {
        .ant-menu-submenu-arrow {
          &::after {
            transform: translateY(-50%) rotate(180deg);
          }
        }
      }
      
      // 处理嵌套子菜单的箭头方向
      .ant-menu-submenu {
        .ant-menu-submenu-arrow {
          &::after {
            transform: translateY(-50%) rotate(0deg);
          }
        }
        
        &.ant-menu-submenu-open {
          .ant-menu-submenu-arrow {
            &::after {
              transform: translateY(-50%) rotate(180deg);
            }
          }
        }
      }
      
      // 子菜单项专用样式
      &.submenu-item {
       .ant-menu-submenu-title{
        padding-left: 48px !important;
       }
       .ant-menu-item{
        padding-left: 60px !important;
       }
        .ant-menu-submenu-arrow {
          &::after {
            transform: translateY(-50%) rotate(0deg) !important;
          }
        }
        
        &.ant-menu-submenu-open {
          .ant-menu-submenu-arrow {
            &::after {
              transform: translateY(-50%) rotate(180deg) !important;
            }
          }
        }
      }
    }
  }
}

.bottom-entries {
  padding-bottom: 12px;

  :deep(.ant) {
    &-menu {
      &-item {
        padding-left: 12px !important;

        >.icon {
          width: 24px;
          height: 24px;
          padding: 4px;
          font-size: 16px;
          line-height: 24px;
          margin-right: 12px;
          text-align: center;
          border-radius: 6px;
          color: var(--dark-1);
          display: inline-block;
          background: var(--yellow-1);

          &-help {
            background: var(--bg-gray-4);
          }

          &-contact-us {
            background: var(--bg-gray-4);
          }
        }

        &-selected {
          opacity: 1;
          font-weight: 600;
          color: var(--dark-1);
          background: none;

          &:hover {
            color: var(--dark-1) !important;
            background-color: var(--bg-gray-6) !important;
          }

          &:active {
            background-color: var(--bg-gray-4) !important;
            font-weight: 600 !important;
          }

          &:after {
            display: none;
          }
        }
      }

      &-title-content {
        margin-inline-start: 0 !important;
      }
    }
  }
}
</style>